import { useEffect, useState } from 'react';
import { InstagramTopPostNewMetrics } from 'components/Post/Post';
import Post from '../../Post';
import { getThumbnail } from 'utils/api/instagram.api';
import { useQueryClient } from 'react-query';

function InstagramSortableTopPosts({
    topPostsQuery,
    sortOption,
    displayQty = 5,
    PostComponent = InstagramTopPostNewMetrics,
    ...props
}) {
    const queryClient = useQueryClient();
    const posts = topPostsQuery.data;

    const [numToDisplay, setNumToDisplay] = useState(displayQty);

    useEffect(() => {
        setNumToDisplay(displayQty);
    }, [displayQty]);

    // Prefetch thumbnails for next batch of Instagram posts
    useEffect(() => {
        if (!posts || posts.length === 0) return;

        const nextBatchStart = numToDisplay;
        const nextBatchEnd = Math.min(numToDisplay + displayQty, posts.length);
        const nextBatch = posts.slice(nextBatchStart, nextBatchEnd);

        nextBatch.forEach((post) => {
            if (post.url && post.url.includes('instagram.com')) {
                const shortcode = post.url.match(/\/p\/([A-Za-z0-9_-]+)/)?.[1];
                if (shortcode) {
                    queryClient.prefetchQuery({
                        queryKey: ['instagram-thumbnail', shortcode],
                        queryFn: () => getThumbnail(shortcode),
                        cacheTime: /** 1 hour */ 60 * 60 * 1000,
                        staleTime: /** 1 hour */ 60 * 60 * 1000,
                        retry: false, // Backend handles retries
                    });
                }
            }
        });
    }, [posts, numToDisplay, displayQty, queryClient]);

    return (
        <Post
            posts={posts}
            isLoading={topPostsQuery.isLoading || topPostsQuery.isIdle}
            isError={topPostsQuery.isError}
            sortOption={sortOption}
            displayQty={displayQty}
            numToDisplay={numToDisplay}
            onNumToDisplayChange={setNumToDisplay}
            PostComponent={PostComponent}
            {...props}
        />
    );
}

export default InstagramSortableTopPosts;
